export enum LanguageCode {
  /* 中文 */
  zhHans = 'zh-Hans',
  /* 繁体 */
  zhHant = 'zh-Hant',
  zh = 'zh',
  /* 英文 */
  en = 'en',
  /* 葡萄牙 */
  pt = 'pt',
  /* 日语 */
  ja = 'ja',
  /* 德语 */
  de = 'de',
  /* 韩语 */
  kor = 'kor',
  /* 印尼语 */
  id = 'id',
  /* 越南语 */
  vi = 'vi',
  /* 泰国语 */
  th = 'th',
  /* 俄语 */
  ru = 'ru',
  /* 法语 */
  fr = 'fr',
  /* 西班牙语 */
  es = 'es',
  /* 意大利语 */
  it = 'it',
  /* 阿拉伯语 */
  ar = 'ar',
  /* 马来西亚语 */
  ms = 'ms',
  /* 土耳其语 */
  te = 'te',
  /* 匈牙利语 */
  hu = 'hu',
  /* 荷兰语 */
  nl = 'nl',
  /* 波兰语 */
  pl = 'pl',
  /* 瑞典语 */
  sv = 'sv',
  /* 罗马尼亚语 */
  ro = 'ro',
  /* 印度语 */
  hi = 'hi',
  /* 波斯语 */
  fa = 'fa',
}
